module.exports = __webpack_public_path__ + "media/images/group-3@2x-d2d808ef3631b56daf70066f3a9f65ad.png";